export default __webpack_public_path__ + "b615e72d08d5aeda6e38289a81c6f004.svg";